exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "div.footer {\n    background-color: #e7f0f7;\n    position: relative;\n    float: left;\n    left: 0;\n    right: 0;\n    width: 100%;\n}", "", {"version":3,"sources":["/home/dev/feildforce/client/app/footer/footer.component.css"],"names":[],"mappings":"AAAA;IACI,0BAA0B;IAC1B,mBAAmB;IACnB,YAAY;IACZ,QAAQ;IACR,SAAS;IACT,YAAY;CACf","file":"footer.component.css","sourcesContent":["div.footer {\n    background-color: #e7f0f7;\n    position: relative;\n    float: left;\n    left: 0;\n    right: 0;\n    width: 100%;\n}"],"sourceRoot":""}]);

// exports
